import _objectSpread from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { createPayment, confirmPayment } from './StripePaymentForm.config.js';
import errorCodeConstants from '../../constants/errorCodeConstants.js';
import paymentMethodTypes from '../../constants/paymentMethodTypeConstants.js';
import paymentStatus from '../../constants/paymentStatusConstants.js';
import billingAddressHasRequiredFields from '../../utils/billingAddressHasRequiredFields.js';
import mapBillingDetailsToStripe from '../../utils/mapBillingDetailsToStripe.js';
import { checkIsCardCheckout, checkIsExpressCheckout } from '../../utils/paymentMethod.js';
import StripeExpressCheckoutElement from './stripe-express-checkout-element/StripeExpressCheckoutElement.js';
import StripePaymentElement from './stripe-payment-element/StripePaymentElement.js';
var StripePaymentForm = function StripePaymentForm(_ref) {
  var amount = _ref.amount,
    afterFormContent = _ref.afterFormContent,
    beforeButtonContent = _ref.beforeButtonContent,
    billing_details = _ref.billingDetails,
    classNames = _ref.classNames,
    isStubbed = _ref.isStubbed,
    metadata = _ref.metadata,
    _ref$onReadyToRenderH = _ref.onReadyToRenderHandler,
    onReadyToRenderHandler = _ref$onReadyToRenderH === void 0 ? function () {} : _ref$onReadyToRenderH,
    paymentHandlers = _ref.paymentHandlers,
    _ref$paymentMethodTyp = _ref.paymentMethodType,
    paymentMethodType = _ref$paymentMethodTyp === void 0 ? paymentMethodTypes.CARD : _ref$paymentMethodTyp,
    renderPaymentButton = _ref.renderPaymentButton;
  var stripe = useStripe();
  var elements = useElements();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var isCardCheckout = checkIsCardCheckout(paymentMethodType);
  var isExpressCheckout = checkIsExpressCheckout(paymentMethodType);
  var handleError = function handleError(error) {
    var _paymentHandlers$onEr;
    if (error && Object.keys(error).length > 0) {
      setIsLoading(false);
    }
    paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onEr = paymentHandlers.onError) === null || _paymentHandlers$onEr === void 0 || _paymentHandlers$onEr.call(paymentHandlers, error);
  };
  var checkHasRequiredFields = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var billingDetails;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            billingDetails = _ref2.billingDetails;
            if (billingAddressHasRequiredFields(billingDetails)) {
              _context.next = 4;
              break;
            }
            handleError({
              code: errorCodeConstants.STRIPE_BILLING_DETAILS_INCOMPLETE
            });
            return _context.abrupt("return", false);
          case 4:
            return _context.abrupt("return", true);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function checkHasRequiredFields(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var toggleLoading = function toggleLoading(loading) {
    setIsLoading(loading);
    if (loading) {
      handleError({});
    }
  };
  var submitElements = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref4) {
      var elements, _yield$elements$submi, error;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            elements = _ref4.elements;
            _context2.next = 3;
            return elements.submit();
          case 3:
            _yield$elements$submi = _context2.sent;
            error = _yield$elements$submi.error;
            if (!error) {
              _context2.next = 8;
              break;
            }
            handleError(error);
            return _context2.abrupt("return", false);
          case 8:
            return _context2.abrupt("return", true);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function submitElements(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var createPaymentMethod = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref6) {
      var billing_details, elements, stripe, _yield$stripe$createP, createPaymentMethodError, paymentMethod;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            billing_details = _ref6.billingDetails, elements = _ref6.elements, stripe = _ref6.stripe;
            _context3.next = 3;
            return stripe.createPaymentMethod({
              elements: elements,
              params: {
                billing_details: billing_details,
                metadata: metadata
              }
            });
          case 3:
            _yield$stripe$createP = _context3.sent;
            createPaymentMethodError = _yield$stripe$createP.error;
            paymentMethod = _yield$stripe$createP.paymentMethod;
            if (!createPaymentMethodError) {
              _context3.next = 9;
              break;
            }
            handleError(_objectSpread(_objectSpread({}, createPaymentMethodError), {}, {
              code: errorCodeConstants.STRIPE_DEFAULT_ERROR
            }));
            return _context3.abrupt("return", null);
          case 9:
            return _context3.abrupt("return", paymentMethod);
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function createPaymentMethod(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();
  var processPayment = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref8) {
      var billingDetails, paymentMethodId, stripe, stubbedStatus, identifier, _yield$createPayment, clientSecret, jlppr, status, _yield$stripe$handleN, handleNextActionError, response, _paymentHandlers$onPa, _paymentHandlers$onPa2;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            billingDetails = _ref8.billingDetails, paymentMethodId = _ref8.paymentMethodId, stripe = _ref8.stripe, stubbedStatus = _ref8.stubbedStatus;
            identifier = stubbedStatus !== null && stubbedStatus !== void 0 ? stubbedStatus : paymentMethodId;
            if (identifier) {
              _context4.next = 5;
              break;
            }
            console.warn('No payment method or stubbed status provided.');
            return _context4.abrupt("return");
          case 5:
            console.log('debug: processPayment(): 1.');
            _context4.prev = 6;
            _context4.next = 9;
            return createPayment(identifier);
          case 9:
            _yield$createPayment = _context4.sent;
            clientSecret = _yield$createPayment.clientSecret;
            jlppr = _yield$createPayment.jlppr;
            status = _yield$createPayment.status;
            console.log('debug: processPayment(): status.', status);
            if (!(status === paymentStatus.DECLINED)) {
              _context4.next = 18;
              break;
            }
            console.log('debug: processPayment(): 2. DECLINED');
            handleError({
              code: errorCodeConstants.STRIPE_PAYMENT_DECLINED
            });
            return _context4.abrupt("return");
          case 18:
            if (!(status === paymentStatus.CREATED)) {
              _context4.next = 37;
              break;
            }
            console.log('debug: processPayment(): 2. CREATED');
            if (!(!stubbedStatus && stripe && clientSecret)) {
              _context4.next = 28;
              break;
            }
            _context4.next = 23;
            return stripe.handleNextAction({
              clientSecret: clientSecret
            });
          case 23:
            _yield$stripe$handleN = _context4.sent;
            handleNextActionError = _yield$stripe$handleN.error;
            if (!handleNextActionError) {
              _context4.next = 28;
              break;
            }
            handleError(handleNextActionError);
            return _context4.abrupt("return");
          case 28:
            _context4.next = 30;
            return confirmPayment(jlppr);
          case 30:
            response = _context4.sent;
            if (!response) {
              _context4.next = 37;
              break;
            }
            if (paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.onPaymentSuccess) {
              _context4.next = 35;
              break;
            }
            console.warn('No payment success handler provided.');
            return _context4.abrupt("return");
          case 35:
            _context4.next = 37;
            return paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onPa = paymentHandlers.onPaymentSuccess) === null || _paymentHandlers$onPa === void 0 ? void 0 : _paymentHandlers$onPa.call(paymentHandlers, {
              billingDetails: billingDetails
            });
          case 37:
            if (!(status === paymentStatus.AUTHORISED)) {
              _context4.next = 44;
              break;
            }
            console.log('debug: processPayment(): 2. AUTHORISED');
            if (paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.onPaymentSuccess) {
              _context4.next = 42;
              break;
            }
            console.warn('No payment success handler provided.');
            return _context4.abrupt("return");
          case 42:
            _context4.next = 44;
            return paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onPa2 = paymentHandlers.onPaymentSuccess) === null || _paymentHandlers$onPa2 === void 0 ? void 0 : _paymentHandlers$onPa2.call(paymentHandlers, {
              billingDetails: billingDetails
            });
          case 44:
            _context4.next = 49;
            break;
          case 46:
            _context4.prev = 46;
            _context4.t0 = _context4["catch"](6);
            handleError(_objectSpread(_objectSpread({}, _context4.t0), {}, {
              code: errorCodeConstants.STRIPE_DEFAULT_ERROR
            }));
          case 49:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[6, 46]]);
    }));
    return function processPayment(_x4) {
      return _ref9.apply(this, arguments);
    };
  }();
  var onSubmitHandler = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref10) {
      var _normalisedBillingDet, _paymentHandlers$onBu;
      var billingDetails, selectedShippingOptionIdentifier, shippingAddress, stubbedStatus, normalisedBillingDetails, normalisedShippingAddress, paymentMethod;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            billingDetails = _ref10.billingDetails, selectedShippingOptionIdentifier = _ref10.selectedShippingOptionIdentifier, shippingAddress = _ref10.shippingAddress, stubbedStatus = _ref10.stubbedStatus;
            normalisedBillingDetails = mapBillingDetailsToStripe(billingDetails);
            normalisedShippingAddress = _objectSpread(_objectSpread({}, shippingAddress), {}, {
              phone: (_normalisedBillingDet = normalisedBillingDetails === null || normalisedBillingDetails === void 0 ? void 0 : normalisedBillingDetails.phone) !== null && _normalisedBillingDet !== void 0 ? _normalisedBillingDet : ''
            });
            toggleLoading(true);
            if (!(!isStubbed && (!stripe || !elements))) {
              _context5.next = 7;
              break;
            }
            handleError({
              code: errorCodeConstants.STRIPE_NOT_LOADED
            });
            return _context5.abrupt("return");
          case 7:
            _context5.next = 9;
            return paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onBu = paymentHandlers.onButtonClick) === null || _paymentHandlers$onBu === void 0 ? void 0 : _paymentHandlers$onBu.call(paymentHandlers, {
              selectedShippingOptionIdentifier: selectedShippingOptionIdentifier,
              shippingAddress: normalisedShippingAddress
            });
          case 9:
            if (_context5.sent) {
              _context5.next = 12;
              break;
            }
            toggleLoading(false);
            return _context5.abrupt("return");
          case 12:
            _context5.prev = 12;
            _context5.t0 = !isStubbed;
            if (!_context5.t0) {
              _context5.next = 18;
              break;
            }
            _context5.next = 17;
            return submitElements({
              elements: elements
            });
          case 17:
            _context5.t0 = !_context5.sent;
          case 18:
            if (!_context5.t0) {
              _context5.next = 20;
              break;
            }
            return _context5.abrupt("return");
          case 20:
            console.log('debug: StripePaymentForm() 5');
            _context5.next = 23;
            return checkHasRequiredFields({
              billingDetails: normalisedBillingDetails
            });
          case 23:
            if (_context5.sent) {
              _context5.next = 25;
              break;
            }
            return _context5.abrupt("return");
          case 25:
            console.log('debug: StripePaymentForm() 6');
            if (!isStubbed) {
              _context5.next = 31;
              break;
            }
            _context5.next = 29;
            return processPayment({
              billingDetails: normalisedBillingDetails,
              stubbedStatus: stubbedStatus
            });
          case 29:
            console.log('debug: StripePaymentForm() 6 isStubbed return');
            return _context5.abrupt("return");
          case 31:
            _context5.next = 33;
            return createPaymentMethod({
              billingDetails: normalisedBillingDetails,
              elements: elements,
              stripe: stripe
            });
          case 33:
            paymentMethod = _context5.sent;
            if (paymentMethod) {
              _context5.next = 36;
              break;
            }
            return _context5.abrupt("return");
          case 36:
            console.log('debug: StripePaymentForm() 7');
            _context5.next = 39;
            return processPayment({
              billingDetails: normalisedBillingDetails,
              paymentMethodId: paymentMethod.id,
              stripe: stripe
            });
          case 39:
            console.log('debug: StripePaymentForm() 8');
            _context5.next = 45;
            break;
          case 42:
            _context5.prev = 42;
            _context5.t1 = _context5["catch"](12);
            handleError(_objectSpread(_objectSpread({}, _context5.t1), {}, {
              code: errorCodeConstants.STRIPE_DEFAULT_ERROR
            }));
          case 45:
            _context5.prev = 45;
            toggleLoading(false);
            return _context5.finish(45);
          case 48:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[12, 42, 45, 48]]);
    }));
    return function onSubmitHandler(_x5) {
      return _ref11.apply(this, arguments);
    };
  }();
  return React.createElement("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.container
  }, isExpressCheckout && React.createElement(StripeExpressCheckoutElement, {
    amount: amount,
    billingDetails: billing_details,
    classNames: classNames,
    elements: elements,
    isStubbed: isStubbed,
    onReadyToRenderHandler: onReadyToRenderHandler,
    onSubmitHandler: onSubmitHandler,
    paymentHandlers: paymentHandlers,
    paymentMethodType: paymentMethodType
  }), isCardCheckout && React.createElement(StripePaymentElement, {
    beforeButtonContent: beforeButtonContent,
    billingDetails: billing_details,
    classNames: classNames,
    isDisabled: !stripe || isLoading,
    isStubbed: isStubbed,
    onReadyToRenderHandler: onReadyToRenderHandler,
    onSubmitHandler: onSubmitHandler,
    renderPaymentButton: renderPaymentButton
  }), React.createElement("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.afterFormContent
  }, afterFormContent));
};
export { StripePaymentForm as default };